import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a50f064ab353691e215d9b43ba3fc10b5b from "./generated-58fc672d-0b91-4b43-8284-e557cd9cfeb1.json";

import a09244357b0301fef9fdecbba6e6cfa22b from "./generated-c1940e30-7976-4087-ae0d-210366b60d1f.json";

import a0119f7e1c8a413d1a2579b4971ce091eb from "./generated-ac13eb22-e3b8-4016-b871-43a979103149.json";

import a8b2c0bedd7f67e09763298abfdb23a7ab from "./generated-b3b10011-0ea5-4cfd-87a1-732ec0a72c2f.json";

import a1f87bedda4405561a42142ad95d1b7b1b from "./generated-426f8d95-c047-4932-b2c1-f0bba90b07ba.json";

import a386bdea921019010caba236ccecac598b from "./generated-6cd1263b-e2bd-4b3c-8823-6e7c1a4e9a59.json";

import a3b25ea6798391764dc4d62b49b204dcdb from "./generated-fa72d330-f268-48b5-b4f1-5945f5f02cc7.json";

import a528f122e9cc7c29fa19a95785e334707b from "./generated-613d60ac-c2f8-490a-9306-7acc8ecb756a.json";

import abe0bc18a01930511d26b92036ccaf441b from "./generated-7f0d6591-cc41-40dd-8d22-00593812a908.json";

import a3d88f2e9517a822e8e8c94bee0460d1fb from "./generated-8889e90c-8886-4b09-967a-34e5de881feb.json";

import a962c8786d688d9aa42185853bc51bbecb from "./generated-fa61a628-c194-4a2d-80f6-02ba1b110dd5.json";

import a4f41f10a9eb4d7fcb7b37da3c28916dcb from "./generated-337dfb3a-fc40-42ca-a7eb-d2253d3164cc.json";

import aeea2bd3ad3282fe8d230e3adb2d09298b from "./generated-6640dc6f-99c4-4c84-9047-6a7d4d51ad29.json";

import a7baf872308151b154aa62474bf64ba51b from "./generated-9e245676-09ff-48b9-b104-159cfd37a708.json";

import a8f59a3b7ad45e9f296c6304b7cf288b8b from "./generated-20036161-bc14-4fde-9e3f-bdc8733e7256.json";

import afadcdd31249da98e8ad8062890838e98b from "./generated-8e5591f6-b516-48a9-85d0-2858c0470e04.json";

import a429462a82b77350b752186d1a8b54429b from "./generated-d324e11f-e187-4e07-a75c-1ed74122fce5.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a50f064ab353691e215d9b43ba3fc10b5b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a09244357b0301fef9fdecbba6e6cfa22b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a0119f7e1c8a413d1a2579b4971ce091eb);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a8b2c0bedd7f67e09763298abfdb23a7ab);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a1f87bedda4405561a42142ad95d1b7b1b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a386bdea921019010caba236ccecac598b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a3b25ea6798391764dc4d62b49b204dcdb);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a528f122e9cc7c29fa19a95785e334707b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(abe0bc18a01930511d26b92036ccaf441b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a3d88f2e9517a822e8e8c94bee0460d1fb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a962c8786d688d9aa42185853bc51bbecb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a4f41f10a9eb4d7fcb7b37da3c28916dcb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(abe0bc18a01930511d26b92036ccaf441b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(aeea2bd3ad3282fe8d230e3adb2d09298b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a7baf872308151b154aa62474bf64ba51b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(abe0bc18a01930511d26b92036ccaf441b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a8f59a3b7ad45e9f296c6304b7cf288b8b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(afadcdd31249da98e8ad8062890838e98b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a429462a82b77350b752186d1a8b54429b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a8f59a3b7ad45e9f296c6304b7cf288b8b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */